import { linkAffiliatePartner } from 'clients/CustomerClient';
import { useAuth } from 'context/Auth';
import { useEffect, useRef, useState } from 'react';
import {
  affiliateLinkPopupOf,
  clearPendingAffiliateLinkCode,
  getPendingAffiliateLinkCode,
  readAffiliateLinkResult,
  takeAffiliateLinkResult,
} from 'utils/AffiliateLinkUtils';

/**
 * Gắn khách cho CTV sau khi đăng nhập (BV-2399) và trả popup kết quả cần hiện ({ title, content } | null).
 *
 * - Trang /affiliate-partner/register gắn ngay ở server, để kết quả ở cookie affiliate_link_result rồi
 *   chuyển về trang chủ: đọc cookie (xoá luôn) và hiện popup một lần.
 * - Khách mở link khi chưa đăng nhập: mã nằm ở cookie; có user đăng nhập thì gọi API MỘT lần rồi xoá
 *   cookie, bất kể kết quả (máy dùng chung ở nhà thuốc không gắn nhầm người đăng nhập sau) — trừ lỗi
 *   hệ thống / mạng thì giữ để lần sau thử lại. Khách vừa đăng ký bằng chính mã này thì backend trả
 *   REGISTERED (luồng khách mới), không gắn thêm.
 *
 * @returns {[{title: string, content: string} | null, () => void]} popup và hàm đóng popup
 */
export default function useAffiliateLinkClaim() {
  const { isAuthenticated } = useAuth() || {};
  const calledRef = useRef(false);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    const result = takeAffiliateLinkResult();
    if (result) setPopup(affiliateLinkPopupOf(result));
  }, []);

  useEffect(() => {
    if (!isAuthenticated || calledRef.current) return;
    const referCode = getPendingAffiliateLinkCode();
    if (!referCode) return;
    calledRef.current = true;
    linkAffiliatePartner({ referCode })
      .then((res) => {
        const result = readAffiliateLinkResult(res);
        if (!result) return;
        clearPendingAffiliateLinkCode();
        setPopup(affiliateLinkPopupOf(result));
      })
      .catch(() => {});
  }, [isAuthenticated]);

  return [popup, () => setPopup(null)];
}
